export default __webpack_public_path__ + "static/media/icon-payroll.62e1f966.svg";